export default {
  loading: false,
  mgmt_credits: [],
  mgmt_credit: {},
  totalCount: 0,
};
